export { PRIVILEGES } from './privileges'

const SOCKET_IO_PATH = '/sr-documents/v1/docs-web/download'
const SOCKET_IO_PATH_V2 = '/v2/socketio/docs/download'

const SORTING_OPTIONS = ['UPDATED_RECENT', 'UPDATED_OLDER', 'NAME_ASC', 'NAME_DESC']
const INVOICE_SORTING_OPTIONS = ['UPDATED_RECENT', 'UPDATED_OLDER']

const PROJECT_USER_ROLES = ['IMPORTER', 'THIRDPARTY', 'ASSIGNED']

/* the follwing states are not visible
 * { 0: 'DELETED' }
 * { 5: 'CANCELED' }
*/
const ORDER_STATUS = {
	1: 'PENDING',
	2: 'CONFIRMED',
	3: 'PRODUCTION',
	4: 'FINISHED',
}

const ERROR_403_PATH = '/error-403'

const SIGN_UP_DESCRIPTION_BY_ID = { 1: 'Email', 2: 'Facebook', 3: 'Linkedin' }

const CATALOG_IDS = {
	INT: 16,
	int: 16,
	USA: 21,
	usa: 21
}

const CATALOG_CODES = {
	16: 'int',
	21: 'usa'
}

const EXTERNAL_URLS = {
	home: {
		es: '%VIBIA_WEB_URL%/%LANG%/%CATALOG_CODE%',
		en: '%VIBIA_WEB_URL%/%LANG%/%CATALOG_CODE%',
		us: '%VIBIA_WEB_URL%/%LANG%/%CATALOG_CODE%',
		de: '%VIBIA_WEB_URL%/%LANG%/%CATALOG_CODE%',
		it: '%VIBIA_WEB_URL%/%LANG%/%CATALOG_CODE%',
		fr: '%VIBIA_WEB_URL%/%LANG%/%CATALOG_CODE%'
	},
	about: {
		es: '%VIBIA_WEB_URL%/%LANG%/sobre-nosotros',
		en: '%VIBIA_WEB_URL%/%LANG%/about-us',
		us: '%VIBIA_WEB_URL%/%LANG%/about-us',
		de: '%VIBIA_WEB_URL%/%LANG%/uber-uns',
		it: '%VIBIA_WEB_URL%/%LANG%/about-us',
		fr: '%VIBIA_WEB_URL%/%LANG%/about-us'
	},
	contact: {
		es: '%VIBIA_WEB_URL%/%LANG%/%CATALOG_CODE%/contacto',
		en: '%VIBIA_WEB_URL%/%LANG%/%CATALOG_CODE%/contact',
		us: '%VIBIA_WEB_URL%/%LANG%/%CATALOG_CODE%/contact',
		de: '%VIBIA_WEB_URL%/%LANG%/%CATALOG_CODE%/kontakt',
		it: '%VIBIA_WEB_URL%/%LANG%/%CATALOG_CODE%/contatto',
		fr: '%VIBIA_WEB_URL%/%LANG%/%CATALOG_CODE%/contact'
	},
	new_contact: {
		es: '%VIBIA_WEB_URL%/%LANG%/%CATALOG_CODE%/a-tu-lado',
		en: '%VIBIA_WEB_URL%/%LANG%/%CATALOG_CODE%/by-your-side',
		us: '%VIBIA_WEB_URL%/%LANG%/%CATALOG_CODE%/by-your-side',
		de: '%VIBIA_WEB_URL%/%LANG%/%CATALOG_CODE%/an-ihrer-seite',
		it: '%VIBIA_WEB_URL%/%LANG%/%CATALOG_CODE%/al-tuo-fianco',
		fr: '%VIBIA_WEB_URL%/%LANG%/%CATALOG_CODE%/a-vos-cotes'
	},
	collections: {
		es: '%VIBIA_WEB_URL%/%LANG%/%CATALOG_CODE%/colecciones',
		en: '%VIBIA_WEB_URL%/%LANG%/%CATALOG_CODE%/collections',
		us: '%VIBIA_WEB_URL%/%LANG%/%CATALOG_CODE%/collections',
		de: '%VIBIA_WEB_URL%/%LANG%/%CATALOG_CODE%/kollektionen',
		it: '%VIBIA_WEB_URL%/%LANG%/%CATALOG_CODE%/collezioni',
		fr: '%VIBIA_WEB_URL%/%LANG%/%CATALOG_CODE%/collections'
	},
	theEdit: {
		es: '%VIBIA_WEB_URL%/%LANG%/the-edit',
		en: '%VIBIA_WEB_URL%/%LANG%/the-edit',
		us: '%VIBIA_WEB_URL%/%LANG%/the-edit',
		de: '%VIBIA_WEB_URL%/%LANG%/the-edit',
		it: '%VIBIA_WEB_URL%/%LANG%/the-edit',
		fr: '%VIBIA_WEB_URL%/%LANG%/the-edit'
	},
	downloads: {
		es: '%VIBIA_WEB_URL%/%LANG%/%CATALOG_CODE%/descargas',
		en: '%VIBIA_WEB_URL%/%LANG%/%CATALOG_CODE%/downloads',
		us: '%VIBIA_WEB_URL%/%LANG%/%CATALOG_CODE%/downloads',
		de: '%VIBIA_WEB_URL%/%LANG%/%CATALOG_CODE%/downloads',
		it: '%VIBIA_WEB_URL%/%LANG%/%CATALOG_CODE%/scarica',
		fr: '%VIBIA_WEB_URL%/%LANG%/%CATALOG_CODE%/telechargements'
	},
	whereToBuy: {
		es: '%VIBIA_WEB_URL%/%LANG%/%CATALOG_CODE%/donde-comprar',
		en: '%VIBIA_WEB_URL%/%LANG%/%CATALOG_CODE%/where-to-buy',
		us: '%VIBIA_WEB_URL%/%LANG%/%CATALOG_CODE%/where-to-buy',
		de: '%VIBIA_WEB_URL%/%LANG%/%CATALOG_CODE%/verkaufsstellen',
		it: '%VIBIA_WEB_URL%/%LANG%/%CATALOG_CODE%/dove-acquistare',
		fr: '%VIBIA_WEB_URL%/%LANG%/%CATALOG_CODE%/ou-acheter'
	},
	professionalArea: {
		es: '%VIBIA_WEB_URL%/workspace/%LANG%/crea',
		en: '%VIBIA_WEB_URL%/workspace/%LANG%/crea',
		us: '%VIBIA_WEB_URL%/workspace/%LANG%/crea',
		de: '%VIBIA_WEB_URL%/workspace/%LANG%/crea',
		it: '%VIBIA_WEB_URL%/workspace/%LANG%/crea',
		fr: '%VIBIA_WEB_URL%/workspace/%LANG%/crea'
	}
}

const AUTH_VIEWS = {
	login: '',
	passwordReset: 'password-reset',
	passwordChange: 'password-change',
	qualification: 'qualification',
	support: 'support',
	NewRegister: 'new-register'
}

const ALLOWED_ISOCODE_INT = ['es', 'en', 'de', 'it', 'fr']

const MANAGE_USER_ACTION_ACCEPT = 'accept'
const MANAGE_USER_ACTION_REJECT = 'reject'

export {
	CATALOG_IDS,
	CATALOG_CODES,
	SORTING_OPTIONS,
	ORDER_STATUS,
	AUTH_VIEWS,
	PROJECT_USER_ROLES,
	EXTERNAL_URLS,
	SOCKET_IO_PATH,
	SOCKET_IO_PATH_V2,
	ERROR_403_PATH,
	SIGN_UP_DESCRIPTION_BY_ID,
	ALLOWED_ISOCODE_INT,
	INVOICE_SORTING_OPTIONS,
	MANAGE_USER_ACTION_ACCEPT,
	MANAGE_USER_ACTION_REJECT
}
